import extend from "extend";

export interface Config {
	apiHost: string;
	auth0Domain: string;
	auth0ClientId: string;
	responder: string;
	logRocketEnvironmentId: string;
}

export type Environment = "development" | "test" | "staging" | "production";

const base: Partial<Config> = {
	apiHost: "https://localhost:3000",
	auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
	auth0ClientId: process.env.REACT_APP_AUTH0_MANAGER_CLIENT_ID,
	responder: "http://localhost:4040",
	logRocketEnvironmentId: "vurvey/vurvey-creator-dev",
};

const envs: {[key in Environment]: Partial<Config>} = {
	development: {},
	test: {
		apiHost: "https://api-staging.vurvey.dev",
		auth0Domain: "auth.vurvey.dev",
		auth0ClientId: "aCjYSynmLDnMQgp8dpERzygCdr5Y0kZS",
		responder: "https://respond.vurvey.dev",
	},
	staging: {
		apiHost: "https://api-staging.vurvey.dev",
		auth0Domain: "login.vurvey.dev",
		auth0ClientId: "l0r71KhDKGMWestAPuSjeoztk2YS2V1x",
		responder: "https://respond.staging.vurvey.dev",
	},
	production: {
		auth0Domain: "vurvey-prod.us.auth0.com",
		auth0ClientId: "XfFneVDRfGdbkGOnmsfXPHXyQfXxJZcs",
		apiHost: "https://api.vurvey.app",
		responder: "https://respond.vurvey.app",
		logRocketEnvironmentId: "vurvey/vurvey-creator-prod",
	},
};

const env = envs[process.env.REACT_APP_ENV || "dev"];
const config: Config = extend({}, base, env);

export default config;
export {config};
